import { ComponentProps, ElementType, forwardRef } from "react";
import { Menu as BaseMenu } from "@base-ui-components/react/menu";
import { menuItemClasses } from "./MenuItem.style";

export type MenuItemProps = ComponentProps<typeof BaseMenu.Item> & {
  /**
   * The component that renders the root.
   * @default 'div'
   */
  component?: ElementType;
  href?: string;
  divider?: boolean;
};

const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>((props, ref) => {
  const {
    className,
    divider,
    children,
    component: Component = "div",
    ...rest
  } = props;
  return (
    <>
      <BaseMenu.Item
        ref={ref}
        {...rest}
        render={(props) => <Component {...props} />}
        className={menuItemClasses({
          class: typeof className === "string" ? className : "",
        })}
      >
        {children}
      </BaseMenu.Item>
      {divider && (
        <BaseMenu.Separator className="mx-4 my-1.5 h-px bg-gray-200" />
      )}
    </>
  );
});

export default MenuItem;
